import { createTheme } from '@mui/material/styles';

// Material Design theme aligned to the re-stat brand: blue accent (#204ce5)
// and a dark navy app bar (#112337).
const muiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#204ce5', dark: '#001AB3', contrastText: '#ffffff' },
    success: { main: '#11783f' },
    warning: { main: '#d97706' },
    error: { main: '#dc2626' },
    info: { main: '#204ce5' },
    background: { default: '#f5f5f5', paper: '#ffffff' },
    text: { primary: '#112337', secondary: '#595959' },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.02em' },
    h6: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
  },
});

export default muiTheme;
